import React from 'react';

export default function List(props) {
  const { items, renderItem } = props;

  return <div>{items.map(renderItem)}</div>;
}
